export const DECODE_JWT = "DECODE_JWT";
export const DECODE_JWT_SUCCESS = "DECODE_JWT_SUCCESS";
export const DECODE_JWT_ERROR = "DECODE_JWT_ERROR";

export const REFRESH_JWT = "REFRESH_JWT";
export const REFRESH_JWT_SUCCESS = "REFRESH_JWT_SUCCESS";
export const REFRESH_JWT_ERROR = "REFRESH_JWT_ERROR";
